.defaultPaper {
	width: 100% !important;
	height: 150px !important;
	text-align: center !important;
}

.fullHeight {
	height: 100%;
}
